import { z } from 'zod'

type ForgotPasswordFormData = {
  email: string
}

const forgotPasswordFormSchema = z.object({
  email: z.email('forgotPassword.fields.email.errors.invalid_string').max(256)
})

export const validateForgotPasswordForm = (data: ForgotPasswordFormData) => {
  return forgotPasswordFormSchema.safeParse(data)
}
